import BannerZipcode from './BannerZipcode.container';

export default BannerZipcode;
